import React, { useEffect, useState } from "react";
import Web3 from "web3";
import { useAppKitAccount } from "@reown/appkit/react";
import { useConnectorClient } from "wagmi";
import { ITreasureContract, NFTContarct,DepositContract } from "../config/contractConfig";
import ITreasureContractABI from "../abis/ITreasureContractABI.json";
import NFTABI from "../abis/NFTABI.json";
import DepositAbi from "../abis/DepositAbi.json";

import Nodata from "../assets/img/no-record-found.png";
import Loader from "../components/Loader";

import {
  FaWallet,
  FaHashtag,
  FaBoxOpen,
  FaCopy,
  FaCheck,
  FaFilter,
} from "react-icons/fa";

const MyRefferal = () => {
  const { address, isConnected } = useAppKitAccount();
  const { data: client } = useConnectorClient();

  const [web3, setWeb3] = useState(null);
  const [downlines, setDownlines] = useState([]);

  const [lastPackage, setLastPackage] = useState(0); 

  const [currentPage, setCurrentPage] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loading, setLoading] = useState(true);

  const [mobileFilterOpen, setMobileFilterOpen] = useState(false);

  const recordsPerPage = 12;

  // INIT WEB3
  useEffect(() => {
    const initWeb3 = () => {
      let provider = null;

      if (client && client.transport) provider = client.transport;
      else if (typeof window !== "undefined" && window.ethereum)
        provider = window.ethereum;

      if (!provider) {
        setWeb3(null);
        return;
      }

      const w3 = new Web3(provider);
      setWeb3(w3);

      if (provider.on) {
        provider.on("accountsChanged", () => {
          if (address) fetchReferralList();
        });

        provider.on("chainChanged", () => {
          if (address) fetchReferralList();
        });
      }
    };

    initWeb3();
  }, [client]);

  // FETCH REFERRAL LIST
  useEffect(() => {
    if (isConnected && address && web3) fetchReferralList();
  }, [address, isConnected, web3]);

  const packageToDollar = {
  1: 10,
  2: 20,
  3: 50,
  4: 100,
  5: 200,
  6: 400,
  7: 600,
  8: 1000,
  9: 1500
};

 const fetchReferralList = async () => {
  setLoading(true);

  try {
    const GGTInstance = new web3.eth.Contract(
      ITreasureContractABI,
      ITreasureContract
    );

    /* -------------------------
       1) GET DIRECT REFERRALS
    -------------------------- */
    const slot = 0;
    const level = 0;

    const members = await GGTInstance.methods
      .getFetchLevel(address, slot, level)
      .call();

    // filter valid addresses
    const validMembers = members.filter(
      (w) =>
        w &&
        w !== "0x0000000000000000000000000000000000000000" &&
        w !== ""
    );


    /* ---------------------------------------------------------
       2) FETCH EACH REFERRAL'S LAST ACTIVE PACKAGE
    ---------------------------------------------------------- */
    const finalDownlines = [];

    for (let i = 0; i < validMembers.length; i++) {
      const user = validMembers[i];

      // fetch package details
      const packageData = await GGTInstance.methods
        .getPackagePurchaseDetails(user)
        .call();

      const purchased = packageData[0]; // bool[9]

      let lastActive = 0;
      purchased.forEach((val, index) => {
        if (val === true) lastActive = index + 1;
      });

        // ⭐ trading fund details
          const Nftcontract = new web3.eth.Contract(DepositAbi, DepositContract);
       
        const cappingData = await Nftcontract.methods
          .getTradingIncomeCapping(user)
          .call();
      
        const tradeFund = web3.utils.fromWei(
          cappingData.totalDepositFunds,
          "ether"
        );

      // push record
      finalDownlines.push({
        wallet: user,
        slot: 1,
        level: 1,
        dollarValue: packageToDollar[lastActive] || 0 ,
        totalDepositFunds: tradeFund
      });
    }

    setDownlines(finalDownlines);
  } catch (error) {
    console.error("Error fetching referral:", error);
  }

  setLoading(false);
};



  // PAGINATION
  const safeDownlines = Array.isArray(downlines) ? downlines : [];
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = safeDownlines.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );
  const totalPages = Math.ceil(safeDownlines.length / recordsPerPage);

  const resetFilters = () => {
    setSearchValue("");
    setFromDate("");
    setToDate("");
  };

  const [copiedIndex, setCopiedIndex] = useState(null);

  const handleCopy = (text, index) => {
    navigator.clipboard.writeText(text);
    setCopiedIndex(index);
    setTimeout(() => setCopiedIndex(null), 1500);
  };

  // FILTER SEARCH
  const filteredRecords = currentRecords.filter((item) => {
    const search = searchValue.toLowerCase();
    return item.wallet.toLowerCase().includes(search);
  });

  if (loading) return <Loader />;

  return (
    <div className="buyshheikh-page">
      <h4 className="mb-3 mobilefiltername">
        <div>
          <span className="text-warning"> My </span>
          <span className="fw-lighter"> Referral</span>
        </div>
        <button
          className="btn btn-light btn-sm"
          onClick={() => setMobileFilterOpen(true)}
        >
          <FaFilter /> Filter
        </button>
      </h4>


      <div className="card paddingfilter">
        <div className="card-body">
          {mobileFilterOpen && (
            <div
              className="overlay-bg"
              onClick={() => setMobileFilterOpen(false)}
            />
          )}

          {/* MOBILE FILTER */}
          <div
            className={`bottom-filter-panel ${
              mobileFilterOpen ? "show" : ""
            }`}
          >
            <div
              className="close-filter"
              onClick={() => setMobileFilterOpen(false)}
            >
              ✕
            </div>

            <div className="row">
              <div className="col-md-12 col-lg-3 mb-3">
                <label className="form-label">Search Wallet</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search..."
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                />
              </div>

              <div className="col-md-12 col-lg-3 mb-3">
                <label className="visibilty-hidden form-label">btn</label>
                <div className="d-flex gap-2 mobleapplybtn">
                  <button
                    className="btn btn-success"
                    onClick={() => setMobileFilterOpen(false)}
                  >
                    Apply
                  </button>
                  <button className="btn btn-danger" onClick={resetFilters}>
                    Reset
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* DATA LIST */}
          <div className="row">
            {filteredRecords.length > 0 ? (
              filteredRecords.map((item, index) => {
                const w = item.wallet || "";
                const maskAddress =
                  w.length > 4
                    ? w.substring(0, 4) + "****" + w.substring(w.length - 4)
                    : w;

                return (
                  <div className="col-md-6 col-lg-4 mb-4" key={index}>
                    <div className="ref-card">
                      <div className="ref-card-body">
                        <div className="ref-row">
                          <span className="ref-label">
                            <FaHashtag /> S.No.
                          </span>
                          <span className="ref-value">
                            {indexOfFirstRecord + index + 1}
                          </span>
                        </div>

                        <div className="ref-row">
                          <span className="ref-label">
                            <FaWallet /> Wallet
                          </span>
                          <div className="ref-copy-box">
                            <span className="ref-value">{maskAddress}</span>

                            <button
                              className="copy-btn"
                              onClick={() => handleCopy(item.wallet, index)}
                            >
                              {copiedIndex === index ? (
                                <FaCheck className="copy-icon copied" />
                              ) : (
                                <FaCopy className="copy-icon" />
                              )}
                            </button>
                          </div>
                        </div>

                        <div className="ref-row">
                          <span className="ref-label">
                            <FaBoxOpen /> Active Package
                          </span>
                          <span className="ref-value">{item.dollarValue}</span>
                        </div>

                        {/* Trading Fund */}
                        <div className="ref-row">
                          <span className="ref-label">
                            <FaBoxOpen className="ref-icon" /> Trading Fund
                          </span>
                          <span className="ref-value">
                            {item.totalDepositFunds} USDT
                          </span>
                        </div>

                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="no-data">
                <img src={Nodata} alt="No data" />
              </div>
            )}
          </div>

          {/* PAGINATION */}
          {totalPages > 1 && (
            <div className="pagination-div">
              <ul className="pagination mb-0">
                {[...Array(totalPages)].map((_, idx) => (
                  <li
                    key={idx}
                    className={`page-item ${
                      currentPage === idx + 1 ? "active" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => setCurrentPage(idx + 1)}
                    >
                      {idx + 1}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MyRefferal;
